let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k1zH8")).then(() => parcelRequire('58Da3'));